import React from "react"

import {PaymentCurrencyType, StatementItem} from "@irati/types"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import StatusType from "@irati/wallet/types/enums/Status"
import perkboxLogo from "@irati/ui/images/logo-alt.svg"
import withBranding from "@irati/brand/withBranding"
import {getNormalisedValue} from "@irati/utils/currency/formatCurrency"
import authentication from "@irati/auth"

import PrimaryDetails from "../PrimaryDetails"
import {StyledCard} from "../styled"

interface Props extends InjectIntl {
  statementItem: StatementItem
  className?: string
}

const messages = {
  [StatusType.SPENT]: "wallet.statementItem.adminReward.manual_transfer.sent",
  [StatusType.CLEARED]: "wallet.statementItem.adminReward.manual_transfer.received"
}

const ManualPointsTransfer = (props: Props) => {
  const {statementItem, formatMessage} = props
  const {currency, amount, sourceUser, message} = statementItem.transfer || {}
  const status = sourceUser?.email === authentication.user().email ? StatusType.SPENT : StatusType.CLEARED
  const title = formatMessage({id: messages[status]})
  const primaryDetails = {
    image: perkboxLogo,
    title,
    subTitle: message,
    amount: getNormalisedValue(currency !== PaymentCurrencyType.Tt, currency, Math.abs(amount)),
    currency,
    status
  }
  return (
    <StyledCard medium noBorder>
      <PrimaryDetails imgHeightAuto data={primaryDetails} />
    </StyledCard>
  )
}

export default injectIntl(withBranding(ManualPointsTransfer))
